/**
 * Created by lenovo on 2017/2/14.
 */
import React, {
    Component,
    PropTypes
} from 'react';
import {
    Link
} from "react-router";
var ReactBsTable = require('react-bootstrap-table');
var BootstrapTable = ReactBsTable.BootstrapTable;
var TableHeaderColumn = ReactBsTable.TableHeaderColumn;
import ellaService from 'SERVICES/purifier/ella/ellaService'

import Tip from 'COMPONENT/tip'
import {language,errorShow,pageOption} from 'UTIL/common'
import {ellaUrl} from '../../path.config'
import {timesTampsToData} from '../../function'
import ModalDel from 'COMPONENT/ModalDel'
import LongSearchInput from 'CONFIG/component/search/longSearchInput'
export default class APPIndex extends Component {
    constructor(props) {
        super(props);
        this.handle = this.handle.bind(this);
        this.search = this.search.bind(this);
        this.onPageChange = this.onPageChange.bind(this);
        this.date = this.date.bind(this);
        this.delList = this.delList;
        this.del = this.del.bind(this);
        this.state = {
            list: [],
            pageSize: 10,
            page: 1,
            total: 0,
            delRow: {},
            url:ellaUrl,
        }
    };
    componentDidMount() {
        this.onPageChange(this.state.page,this.state.pageSize);
    }
    handle(cell, row) {
        const edit_url = "/ella/appEdit/" + row.id;
        return <div>
            <Link to={edit_url}  className="btn btn-info btn-sm">{language()['edit']}</Link>&nbsp;&nbsp;
            <a  className={row.number == "ella"?"hidden":"btn btn-danger btn-sm"} data-target="#delModal" data-toggle="modal"
                onClick={this.delList.bind(this,row.id,row.operation)}>{language()['delete']}</a>
        </div>

    };
    delList(id, name, e) {
        const delList = {
            "id": id,
            "name": name
        };
        this.setState({
            delRow: delList,
        })
    }
    del() {
        const id = this.state.delRow.id;
        ellaService.appversionDelete(id).then(body=>{
            if (body.code == 8001) {
                $("#success_msg").text(body.msg);
                $("#success_tip").removeClass("hidden");
                this.onPageChange(1,10);
                setTimeout(function() {
                    $("#success_tip").addClass("hidden");
                }, 3000);

            } else {
                $("#error_msg").text(body.msg);
                $("#error_tip").removeClass("hidden");
                setTimeout(function() {
                    $("#error_tip").addClass("hidden");
                }, 3000);
            }
        })
    }
    date(cell,row){
        return row.date == null||''||undefined?'':timesTampsToData(row.date);
    }
    search() {
        this.onPageChange(1,this.state.pageSize);
    }
    onPageChange(page, sizePerPage, e) {
        const json = {
            "page": page,
            "pageSize": sizePerPage,
            search : $.trim($("#search").val())
        };
        var data =JSON.stringify(json);
        ellaService.appversionList({data}).then(body=>{
            console.log(body)
            if(body.code == 8001){
                const json = body.data;
                this.setState({
                    list : json.records,
                    total : json.total,
                    page: page,
                    pageSize: sizePerPage,
                })
            }
        })
    }
    reset(){
        $("#search").val('');
        this.onPageChange(1,10)
    }
    render() {
        let options = pageOption(this.state.page,this.state.pageSize);
        options['onPageChange'] = this.onPageChange.bind(this);
        const create_url = "/ella/appCreate";
        return (
            <div >
                <section className="content-header " >
                    <h1> {language()['APPManagement']} <small>{language()['APPVersionsList']}</small> </h1>
                </section>
                <section className="content" >
                    <div className="box box-primary color-palette-box">
                        <div className="box-header with-border">
                            <i className="fa fa-list"></i>
                            <h3 className="box-title">{language()['APPVersionsList']}</h3>
                            <div style={{marginRight:"10px",float:"right"}}>
                                <Link  to ={create_url} className="btn btn-success btn-md"  >
                                    <i className="fa fa-plus-circle"></i> {language()['add']}
                                </Link>
                            </div>
                        </div>
                        <div className="box-body">
                            <Tip ids=""/>
                            <div className="title-box">
                                <div className="clearfix">
                                    <LongSearchInput id="search" name={language()['systemType']+"/"+language()['systemName']
                                    +"/"+language()['versionNumber']+"/"+language()['download']}
                                    />
                                    <button type="button" className="btn btn-info" onClick={this.search.bind(this)}>{language()['query']}</button>
                                    &nbsp;&nbsp;
                                    <button type="button" className="btn btn-warning" id="reset" onClick={this.reset.bind(this)}>
                                        {language()['resetting']}
                                        </button>
                                </div>
                            </div>
                            <div >
                                <BootstrapTable data = {this.state.list}  remote={true} fetchInfo={{ dataTotalSize: this.state.total }}  striped hover pagination={true} options={options}  >
                                    <TableHeaderColumn isKey dataField='id' hidden={true}>id </TableHeaderColumn>
                                    <TableHeaderColumn dataField='operation' width="150"> {language()['systemType']} </TableHeaderColumn>
                                    <TableHeaderColumn  dataField='versionName'  width="120">{language()['systemName']}</TableHeaderColumn>
                                    <TableHeaderColumn  dataField='versionCode'  width="120">{language()['versionNumber']}</TableHeaderColumn>
                                    <TableHeaderColumn  dataField='date'  width="150" dataFormat={this.date}>{language()['versionTime']}</TableHeaderColumn>
                                    <TableHeaderColumn  dataField='url'  width="200">{language()['download']}</TableHeaderColumn>
                                    <TableHeaderColumn  dataFormat={this.handle}  width="150" columnClassName="td-mid">{language()['operation']}</TableHeaderColumn>
                                </BootstrapTable>
                            </div>
                        </div>
                    </div>
                </section>
                <ModalDel delModSure={this.del} id="delModal"/>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./modules/ella/app/appIndex.js